import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageTopicVideos({ topicID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function updateTopicVideos(data = {}) {
    return privateFetch.put(`/v1/admin/topic/${topicID}/video`, data);
  }

  function uploadTopicVideos(data = {}, headers = {}) {
    return privateFetch.post(`/v1/admin/topic/${topicID}/video`, data?.data, {
      headers,
      params: { subtopicID: data?.subtopicID },
    });
  }

  function reOrderTopicVideos(data = {}) {
    return privateFetch.patch(`/v1/admin/content/video/reorder`, data);
  }

  function deleteTopicVideo({ videoID } = {}) {
    return privateFetch.delete(`/v1/admin/topic/${topicID}/video/${videoID}`);
  }

  function manageTopicsSections({ type, headers = {}, ...data }) {
    if (type === 'UPLOAD_VIDEOS') {
      return uploadTopicVideos(data, headers);
    }

    if (type === 'REORDER') {
      return reOrderTopicVideos(data);
    }

    if (type === 'DELETE') {
      return deleteTopicVideo(data);
    }

    return updateTopicVideos(data);
  }

  return useMutation(manageTopicsSections, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('topic-details');
    },
  });
}

export default useManageTopicVideos;
